import { render, staticRenderFns } from "./copy-btn.vue?vue&type=template&id=4b2327da&scoped=true"
import script from "./copy-btn.vue?vue&type=script&lang=js"
export * from "./copy-btn.vue?vue&type=script&lang=js"
import style0 from "./copy-btn.vue?vue&type=style&index=0&id=4b2327da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2327da",
  null
  
)

export default component.exports